<style>
  .unread {
    font-weight: bold;
    font-size: 1.2em;
    cursor: pointer;
  }
  .read {
    cursor: pointer;
    color: #777;
  }
  .read td {
    font-size: 0.8em;
  }
</style>
<template>
    <div class="app-form frame-page basic-form-vue">
      <Loading text="Carregando" :loading="loading"></Loading>
      <div class="h-panel">
        <div class="h-panel-bar">
          <span class="h-panel-title">{{mensagem.titulo}}</span>
          em {{criadoEmFormatado}}
        </div>

        <div class="h-panel-body" ref="mensagem" style="overflow-x: scroll; max-height: 30em"></div>

        <div class="h-panel-bar">
          <a class="h-btn h-btn-green" v-if="mensagem.link !== '' && mensagem.link !== null" target="_blank" :href="mensagem.link">
            Veja detalhes
          </a>

          <!--
          <button v-if="mensagem.lida" class="h-btn" title="marcar como não lida" @click="marcarComoNaoLida()">
            <i class="fas fa-envelope"></i>
            <span>Marcar como não lida</span>
          </button>
          -->
        </div>
      </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      mensagem: {}
    };
  },
  computed: {
    criadoEmFormatado() {
      return Utils.formatDateTime(this.mensagem.criadoEm);
    }
  },
  mounted() {
    this.loading = true;
    R.Notificacao.getMensagem(this.$route.params.id)
      .then(resp => {
        this.loading = false;
        if (resp.ok === false) {
          this.$router.push('/404');
        } else if (resp.ok === true) {
          this.$root.$emit('hook:update_mensagens');

          // fazendo dessa forma por que se a mensagem for muito grande o vuejs trava o browser
          let msg = resp.data.mensagem;
          if (this.$refs.mensagem) {
            this.$refs.mensagem.innerHTML = msg;
          }
          delete resp.data.mensagem;

          this.mensagem = resp.data;
        }
      });
  },

  methods: {
    marcarComoNaoLida() {
      R.Notificacao.marcarComoNaoLida([this.mensagem._id])
        .then(() => {
          this.$router.push('/notificacao');
        });
    }
  }
};
</script>
